import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import { CurrencyProvider } from "@/lib/currency";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Countries from "@/pages/Countries";
import Pricing from "@/pages/Pricing";
import Partners from "@/pages/Partners";
import Resources from "@/pages/Resources";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import PublicCompany from "@/pages/PublicCompany";

import DashboardShell from "@/pages/app/DashboardShell";
import Overview from "@/pages/app/Overview";
import RegisterWizard from "@/pages/app/RegisterWizard";
import Entities from "@/pages/app/Entities";
import EntityDetail from "@/pages/app/EntityDetail";
import Compliance from "@/pages/app/Compliance";
import Documents from "@/pages/app/Documents";
import Payments from "@/pages/app/Payments";
import PaymentSuccess from "@/pages/app/PaymentSuccess";
import PartnersPanel from "@/pages/app/PartnersPanel";
import Assistant from "@/pages/app/Assistant";
import Ecosystem from "@/pages/app/Ecosystem";
import OrgChart from "@/pages/app/OrgChart";
import Settings from "@/pages/app/Settings";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-artha-ink-soft">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const App = () => (
  <ThemeProvider>
    <CurrencyProvider>
      <AuthProvider>
        <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/countries" element={<Countries />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/company/:slug" element={<PublicCompany />} />

        <Route path="/app" element={<ProtectedRoute><DashboardShell /></ProtectedRoute>}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Overview />} />
          <Route path="register" element={<RegisterWizard />} />
          <Route path="entities" element={<Entities />} />
          <Route path="entities/:id" element={<EntityDetail />} />
          <Route path="compliance" element={<Compliance />} />
          <Route path="documents" element={<Documents />} />
          <Route path="payments" element={<Payments />} />
          <Route path="payments/success" element={<PaymentSuccess />} />
          <Route path="partners" element={<PartnersPanel />} />
          <Route path="assistant" element={<Assistant />} />
          <Route path="ecosystem" element={<Ecosystem />} />
          <Route path="org" element={<OrgChart />} />
          <Route path="settings" element={<Settings />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
      </AuthProvider>
    </CurrencyProvider>
  </ThemeProvider>
);

export default App;
